import { TranslationKeys } from "../contexts/TranslationKeys";
import { Translator } from "../contexts/translator";

export const getDayOptions = (translate: Translator) => {
    return [
        { value: "monday", label: translate.byKey(TranslationKeys.monday) },
        { value: "tuesday", label: translate.byKey(TranslationKeys.tuesday) },
        { value: "wednesday", label: translate.byKey(TranslationKeys.wednesday)},
        { value: "thursday", label: translate.byKey(TranslationKeys.thursday) },
        { value: "friday", label: translate.byKey(TranslationKeys.friday) },
        { value: "saturday", label: translate.byKey(TranslationKeys.saturday) },
        { value: "sunday", label: translate.byKey(TranslationKeys.sunday) },
        { value: "holidays", label: translate.byKey(TranslationKeys.holidays) },
    ];
};
